<template>
  <base-modal class="child-devices-modal"
              height="600"
              :show="show"
              @close="close">
    <div slot="header">
      {{ $t("devicesStatus") }}
    </div>

    <child-devices :child-id="fromBus.childId" />
  </base-modal>
</template>

<script>
  import ChildDevices from '@/components/Child/ChildDevices/ChildDevicesList.vue'
  import modalMixin from '@/mixins/modalMixin.js'

  export default {
    components: {
      ChildDevices
    },

    mixins: [
      modalMixin
    ],

    data() {
      return {
        fromBus: {
          childId: ''
        }
      }
    },

    beforeMount() {
      this.setOpenListener('devicesAndDeviceStatus')
    }
  }
</script>

<style lang="scss" scoped>
  .child-devices-modal {
    :deep(.modal-body) {
      min-height: 400px;
    }
  }
</style>
